module.exports = __webpack_public_path__ + "static/img/68.e5e193c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/22/68.jpg
// module id = 732
// module chunks = 0